import React from "react"
import "./index.css"

const Loader = props => (
  <div className={"full-loader"}>
    <div className="lds-hourglass"></div>
  </div>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/loader/Loader.js